import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {MatTableDataSource} from "@angular/material/table";
import {MatPaginator} from "@angular/material/paginator";
import {Subject, takeUntil} from "rxjs";
import {AdminService} from "../services/admin.service";
import {MatDialog} from "@angular/material/dialog";
import {EditStatusComponent} from "./edit-status/edit-status.component";
import {Pagination, Volunteers} from "../../shared/SharedEntities";
import {AuthenticationService} from "../../auth/services/authentication.service";
import {User} from "../../auth/models/User";

@Component({
  selector: 'app-volunteers',
  templateUrl: './volunteers.component.html',
  styleUrls: ['./volunteers.component.scss']
})
export class VolunteersComponent implements OnInit, AfterViewInit, OnDestroy {
  volunteers = new MatTableDataSource<any>();
  displayedColumns: string[] = ['fullName', 'city', 'gender', 'personalNumber', 'email', 'age', 'status', 'open'];
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  totalItems = 0;
  pageSize = 10;
  currentUser!: User;
  filterFullName: string = '';
  filterPersonalNumber: string = '';
  private destroy$ = new Subject<void>();

  constructor(
    private adminService: AdminService,
    public dialog: MatDialog,
    private authenticationService: AuthenticationService,
  ) {
    this.authenticationService.currentUser.pipe(takeUntil(this.destroy$)).subscribe(x => {
      this.currentUser = x!;
    });
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.loadData();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  loadData(page: number = 0, pageSize: number = this.pageSize, fullName?: string, personalNumber?: string) {
    if (this.currentUser) {
      this.adminService.getAllVolunteers(page, pageSize, fullName, personalNumber).subscribe(
        (result: Pagination<Volunteers>) => {
          this.volunteers = new MatTableDataSource(result.content);
          this.totalItems = result.totalElements;
          this.paginator.length = this.totalItems;
          this.paginator.pageIndex = result.pageable.pageNumber;
        },
        (error: any) => {
          console.error(error);
        }
      );
    }
  }

  openStatusDialog(volunteers: any): void {
    const dialogRef = this.dialog.open(EditStatusComponent, {
      width: '450px',
      height: '300px',
      data: {volunteers}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.loadData();
      }
    });
  }

  onPageChange(event: any) {
    this.loadData(event.pageIndex, event.pageSize, this.filterFullName, this.filterPersonalNumber);
  }

  applyFilter() {
    this.loadData(0, this.pageSize, this.filterFullName, this.filterPersonalNumber);
  }

  clearFilter() {
    this.filterFullName = '';
    this.filterPersonalNumber = '';
    this.loadData(0, this.pageSize, "", "");
  }

}
